import { useEffect, useState } from 'react';

interface UsePriceTimerParams {
    price: string;
    oldPrice: string | null;
    expiresAt: string | null;
}

interface UsePriceTimerResult {
    price: string;
    oldPrice: string | null;
    secondsLeft: number | null;
}

export function usePriceTimer({ price, oldPrice, expiresAt }: UsePriceTimerParams): UsePriceTimerResult {
    const expiresAtMs = oldPrice && expiresAt ? Date.parse(expiresAt) : NaN;
    const hasTimer = !Number.isNaN(expiresAtMs);

    const [now, setNow] = useState<number | null>(null);

    useEffect(() => {
        if (!hasTimer) {
            return;
        }

        setNow(Date.now());

        const id = setInterval(() => {
            const current = Date.now();
            setNow(current);
            if (current >= expiresAtMs) {
                clearInterval(id);
            }
        }, 1000);

        return (): void => clearInterval(id);
    }, [hasTimer, expiresAtMs]);

    if (!hasTimer || now === null) {
        return { price, oldPrice, secondsLeft: null };
    }

    const secondsLeft = Math.ceil((expiresAtMs - now) / 1000);

    if (secondsLeft <= 0) {
        return { price: oldPrice ?? price, oldPrice: null, secondsLeft: null };
    }

    return { price, oldPrice, secondsLeft };
}
